<template>
  <TheUncle :color="true" title="송금" description="사용자 및 관리자에게 송금할 수 있는 곳입니다.">
    <a-spin tip="로딩 중..." :spinning="isLoading">
      <a-card title="송금">
        <a-switch
          @change="
            autoComplete = [];
            search = '';
          "
          checkedChildren="사용자"
          unCheckedChildren="관리자"
          v-model="transform.isUser"
        />
        <a-form-item v-if="transform.isUser" label="사용자:">
          <a-auto-complete
            placeholder="검색"
            v-model="search"
            @search="onSearch"
            :dataSource="autoComplete"
            v-on:keypress.native="onSearchChange"
            style="width: 100%"
          >
            <a-input>
              <a-icon slot="suffix" type="search" @click="onSearch" />
            </a-input>
          </a-auto-complete>
        </a-form-item>
        <a-form-item label="금액:">
          <a-input-number
            :formatter="
              value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            v-model="transform.amount"
            style="width: 90%; margin-right: 5px;"
          />원
        </a-form-item>
        <a-card>
          <a-form-item label="계산">
            <a-input-number
              :formatter="
                value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              v-model="transform.amountDiff"
              style="width: 90%; margin-right: 5px;"
            />원
          </a-form-item>
          <a-button-group>
            <a-button type="primary" icon="plus" @click="updateAmountDiff(true, true)">더하기</a-button>
            <a-button type="danger" icon="minus" @click="updateAmountDiff(false, true)">빼기</a-button>
          </a-button-group>
        </a-card>
        <a-form-item label="사유(충전시 '충전' 작성):">
          <a-input v-model="transform.reason" placeholder="사유" />
        </a-form-item>
        <a-button
          style="margin-top: 30px;"
          :loading="isLoading"
          @click="onTransform"
          type="primary"
          icon="arrow-right"
        >적용</a-button>
      </a-card>
    </a-spin>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "UncleTransform",
  components: { TheUncle },
  mounted() {},
  methods: {
    updateAmountDiff(isPlus) {
      if (this.transform.amountDiff === 0) return;
      const amount = parseInt(this.transform.amount);
      if (isPlus) {
        this.transform.amount = amount + this.transform.amountDiff;
      } else {
        this.transform.amount = amount - this.transform.amountDiff;
      }
      this.transform.amountDiff = 0;
    },
    onSearchChange(e) {
      if (e.key !== "Enter") return;
      this.onSearch();
    },
    async onSearch() {
      if (this.search === "") return;
      const currentTime = new Date();
      if (currentTime - this.latestComplete <= 300) return;
      this.latestComplete = currentTime;

      this.$nextTick(async () => {
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/uncle/transform?q=${this.search}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.autoComplete = data.account.map(
                i => `${i.username}(${i.idx})`
              );
              break;
          }
        }
      });
    },
    async onTransform() {
      try {
        let idx;
        if (this.transform.isUser) {
          const match = this.search.match(/^.*\((.*)\)$/i);
          if (match === null || match.length < 2) {
            this.search = "";
            return config.alert.mixin({
              type: "error",
              title: "대상을 선택해주세요."
            });
          }

          idx = match[1];
        }

        if (!this.transform.amount) {
          return config.alert.mixin({
            type: "error",
            title: "금액을 입력해주세요."
          });
        }

        const { data } = await Axios.post(
          `${config.hostname}/v1/uncle/transform`,
          {
            idx,
            amount: this.transform.amount,
            reason: this.transform.reason
          },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.search = "";
              this.transform.amount = 0;
              this.transform.reason = "충전";
              config.alert.mixin({
                type: "success",
                title: "성공적으로 반영되었습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "송금할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "송금할 수 없습니다."
        });
      }
    }
  },
  data() {
    return {
      isLoading: false,
      latestComplete: new Date(),
      searchs: [],
      autoComplete: [],
      search: "",
      transform: {
        isUser: true,
        amount: 0,
        amountDiff: 0,
        reason: "충전"
      }
    };
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>
